import { InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

interface Branch {
  id: string
  desc: string
}

export const BranchSelect: React.FC<{ value: Branch | null, updateBranch: (branch: Branch | null) => void, disabled: boolean }> = ({ value, updateBranch, disabled }) => {
  const availableBranches = [
    {
      id: 'executive',
      desc: 'Executive'
    },
    {
      id: 'legislative',
      desc: 'Legislative'
    }
  ]

  const handleChange = (value: string | number): void => {
    const selectedBranch = availableBranches.find(branch => branch.id === value)
    updateBranch(selectedBranch ?? null)
  }

  return (
    <React.Fragment>
      <InputLabel>Branch</InputLabel>
      <Select
        label="Branch"
        value={value?.id ?? ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
      >
        <MenuItem value="">
          None
        </MenuItem>
        {availableBranches.map(branch => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.desc}
          </MenuItem>
        ))}
      </Select>
    </React.Fragment>
  )
}
